import axios from 'axios';

export const verifyCaptcha = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/verification`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.data.success === true) {
        onFinish && onFinish(true, res.data);
      }
    })
    .catch((err) => {
      onFinish(false);
      console.log(err);
    });
};
